export default "__VITE_ASSET__Njk5Kk4e__"